module.exports = __webpack_public_path__ + "static/img/50.b87ebdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/50.png
// module id = CU7J
// module chunks = 1